import PropTypes from 'prop-types';
import React from 'react';

import { imagePropTypes } from '../../../propTypes';

import VideoPlayer from '../VideoPlayer';

const propTypes = {
  fallbackImage: imagePropTypes,
  videoUrl: PropTypes.string.isRequired,
};

const defaultProps = {
  fallbackImage: undefined,
};

function Video(props) {
  return (
    <div className="Component Media">
      <div className="Media_content">
        <VideoPlayer videoUrl={props.videoUrl} fallbackImage={props.fallbackImage} />
      </div>
    </div>
  );
}

Video.propTypes = propTypes;
Video.defaultProps = defaultProps;

export default Video;
